module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/trolley_animation-d806b7f4640bababbfb85aee13ea9206.png";